import { useEffect, useState } from 'react';
import {
  Card,
  Container,
  Stack,
  Link,
  Typography,
  TextField,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Button,
  Grid,
  FormControl,
  InputLabel,
  tableCellClasses,
  TextareaAutosize,
  Autocomplete,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { FiEye } from 'react-icons/fi';
import { BiCloudDownload } from 'react-icons/bi';
import { AiFillPrinter, AiFillDelete, AiFillEye } from 'react-icons/ai';
import { Icon } from '@iconify/react';
import add from '@iconify/icons-ic/add';
import remove from '@iconify/icons-ic/sharp-minus';
import { Box } from '@mui/system';
import { Link as RouterLink, Navigate, useNavigate, useParams } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { MdOutlineAdd } from 'react-icons/md';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import partnerService from '../services/partnerService';
import leadsService from '../services/leadsService';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { BankList } = partnerService;
const {
  LeadsSubmissionMode,
  BankBranchList,
  AddBankBranch,
  ContactPersonList,
  AddContactPerson,
  SubmitApplication,
  ListSubmittedApplication
} = leadsService;

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fafbfc'
  },
  '&:hover': {
    backgroundColor: '#f1f5f9'
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '12px 16px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: '#637381',
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '12px 16px',
    borderBottom: '1px solid #f4f6f8'
  }
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'rgba(19, 81, 157, 0.08)',
  color: '#13519d',
  margin: '0 3px',
  '&:hover': {
    backgroundColor: 'rgba(19, 81, 157, 0.16)'
  }
}));

function SubmitLeads() {
  // const [loanInterested, setLoanInterested] = useState(' ');
  // const [selectBank, setSelectBank] = useState(' ');
  const navigate = useNavigate();
  const [selectMode, setSelectMode] = useState(' ');
  const [selectModeList, setSelectModeList] = useState([]);
  const [bankListOpt, setBankListOpt] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [inputBankName, setInputBankName] = useState('');
  const [branches, setBranches] = useState([]);
  const [processCenter, setProcessCenter] = useState('');
  const [processCenterId, setProcessCenterId] = useState(null);
  const [inputProcessingCenter, setInputProcessingCenter] = useState('');
  const [addcontPerson, setAddContPerson] = useState('');
  const [inputContactPerson, setInputContactPerson] = useState('');
  const [bankcontactPersonId, setBankcontactPersonId] = useState(null);
  const [contactPerson, setContactPerson] = useState([]);
  const [summaryComment, setSummaryComment] = useState('');
  const [applicationList, setApplicationList] = useState([]);
  const [refreshComp, setRefreshComp] = useState(null);
  const [validationMsg, setValidationMsg] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);

  const { LoginData } = useLoginSelector();

  // Fill details API
  const token = LoginData?.jwt;
  const companyId = LoginData?.companyId;
  const leadId = JSON.parse(localStorage.getItem('leadId'));
  const applicationId = JSON.parse(localStorage.getItem('applicationId'));

  const handleClose = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    (async () => {
      // Fired Api of Bank name
      const ifPreviewDataBank = await BankList(token);
      if (ifPreviewDataBank.status === 'success') {
        setBankListOpt(ifPreviewDataBank.data.banks);
      } else if (ifPreviewDataBank.status === 'error') {
        localStorage.clear();
        navigate('/');
      }
      // Fired Api of Mode of submission
      const ifFiredLeadsSubmissionModeAPI = await LeadsSubmissionMode(token);
      if (ifFiredLeadsSubmissionModeAPI.status === 'success') {
        setSelectModeList(ifFiredLeadsSubmissionModeAPI.data.leadSubmissionModes);
      }
      // Fired Api of APPLICATION SUMMARY to show the list
      const credential = {
        leadId: leadId,
        applicationId: applicationId
      };
      const ifFiredListApplication = await ListSubmittedApplication(credential, token);
      // console.log('ifFiredListApplication', ListSubmittedApplication);
      if (ifFiredListApplication.status === 'success') {
        // console.log('ifFiredListApplication', ifFiredListApplication);
        setApplicationList(ifFiredListApplication.data.submittedApplications);
      }
    })();
  }, [refreshComp]);

  // Fired Api of Processing Center
  const handleProcessing = () => {
    (async () => {
      const credential = {
        bankId: selectedBankId.bankId,
        branchName: processCenter
      };
      const ifFiredAddBankBranch = await AddBankBranch(credential, token);
      // console.log('ifFiredAddBankBranch', ifFiredAddBankBranch);
      if (ifFiredAddBankBranch.status === 'success') {
        const ifFiredBankBranchList = await BankBranchList(
          {
            bankId: selectedBankId.bankId,
            pageSize: 100,
            pageNumber: 1,
            sortOrder: 'asc'
          },
          token
        );
        console.log('ifFiredBankBranchList', ifFiredBankBranchList);
        setBranches(ifFiredBankBranchList.data.branches);
        // setRefreshComp(new Date());
      }
    })();
  };

  // Fired Api of Branch contact person to Add person
  const handleAddBankPerson = () => {
    (async () => {
      const credential = {
        bankId: selectedBankId.bankId,
        contactPersonName: addcontPerson
      };
      const ifFiredAddContactPersonApi = await AddContactPerson(credential, token);
      // console.log('ifFiredAddContactPersonApi', ifFiredAddContactPersonApi);

      if (ifFiredAddContactPersonApi.status === 'success') {
        const credential = {
          bankId: selectedBankId.bankId,
          searchLiteral: '',
          pageSize: 100,
          pageNumber: 1,
          sortOrder: 'asc'
        };
        const ifFiredContactPersonListApi = await ContactPersonList(credential, token);
        // console.log('ifFiredContactPersonListApi', ifFiredContactPersonListApi);
        setContactPerson(ifFiredContactPersonListApi.data.contactPersons);
      }
    })();
  };

  // Fired Api to submit form of APPLICATION SUMMARY page
  const handleSubmitfrm = async () => {
    if (selectedBankId === null) {
      setDialogOpen(true);
      setValidationMsg('Please select bank name');
      return true;
    }
    if (selectMode === ' ') {
      setDialogOpen(true);
      setValidationMsg('Please select mode');
      return true;
    }
    if (processCenterId === null) {
      setDialogOpen(true);
      setValidationMsg('Please select processing center');
      return true;
    }
    if (bankcontactPersonId === null) {
      setDialogOpen(true);
      setValidationMsg('Please select bank contact person');
      return true;
    }
    if (summaryComment === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter comments');
      return true;
    }

    const credential = {
      submittedToBankId: selectedBankId.bankId,
      leadId: leadId,
      submissionModeTypeId: selectMode,
      processingBankBranch: processCenterId.branchId,
      bankContactPersonId: bankcontactPersonId.contactId,
      submissionComments: summaryComment,
      applicationId: applicationId,
      companyId: companyId
    };
    const ifFiredSubmitApplicationApi = await SubmitApplication(credential, token);
    if (ifFiredSubmitApplicationApi.status === 'success') {
      setInputBankName('');
      setSelectedBankId(null);
      setSelectMode(' ');
      setInputProcessingCenter('');
      setProcessCenterId(null);
      setInputContactPerson('');
      setBankcontactPersonId(null);
      setSummaryComment('');
      setRefreshComp(new Date());
    }
  };

  return (
    <Page title="Kpros by Kalolytic Solutions || Leads">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Application Summary" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
            <Tooltip title="Application View" placement="top" arrow>
              <IconButton
                sx={{
                  bgcolor: 'rgba(19, 81, 157, 0.08)',
                  color: '#13519d',
                  borderRadius: '8px',
                  '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
                }}
              >
                <FiEye size={18} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print" placement="top" arrow>
              <IconButton
                sx={{
                  bgcolor: 'rgba(19, 81, 157, 0.08)',
                  color: '#13519d',
                  borderRadius: '8px',
                  '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
                }}
              >
                <AiFillPrinter size={18} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download" placement="top" arrow>
              <IconButton
                sx={{
                  bgcolor: 'rgba(19, 81, 157, 0.08)',
                  color: '#13519d',
                  borderRadius: '8px',
                  '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
                }}
              >
                <BiCloudDownload size={18} />
              </IconButton>
            </Tooltip>
          </Box>

          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
              p: { xs: 2.5, md: 3.5 },
              mb: 4
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontSize: 16, fontWeight: 700, color: '#13519d', mb: 2.5 }}
            >
              Fill Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Bank Name
                  </Typography>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo2"
                    options={bankListOpt}
                    size="small"
                    getOptionLabel={(option) => option.bankName}
                    renderOption={(props, option) => <li {...props}>{option.bankName}</li>}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth placeholder="Select Bank Name" />
                    )}
                    value={selectedBankId}
                    onChange={async (e, newValue) => {
                      setSelectedBankId(newValue);
                      const ifFiredBankBranchList = await BankBranchList(
                        {
                          bankId: newValue.bankId,
                          pageSize: 100,
                          pageNumber: 1,
                          sortOrder: 'asc'
                        },
                        token
                      );
                      setBranches(ifFiredBankBranchList.data.branches);
                      const credential = {
                        bankId: newValue.bankId,
                        searchLiteral: '',
                        pageSize: 100,
                        pageNumber: 1,
                        sortOrder: 'asc'
                      };
                      const ifFiredContactPersonListApi = await ContactPersonList(
                        credential,
                        token
                      );
                      setContactPerson(ifFiredContactPersonListApi.data.contactPersons);
                    }}
                    inputValue={inputBankName}
                    onInputChange={(_, v) => setInputBankName(v)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Mode of Submission
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${selectMode}`
                    }}
                    value={selectMode}
                    onChange={(e) => setSelectMode(e.target.value)}
                  >
                    <MenuItem value=" " disabled>
                      Select Mode
                    </MenuItem>
                    {selectModeList.map((item, index) => (
                      <MenuItem value={item.typeId} key={index}>
                        {item.typeName}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box className="">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Processing Center
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Autocomplete
                      sx={{ mr: 1.5 }}
                      disablePortal
                      fullWidth
                      id="combo-box-demo2"
                      size="small"
                      options={branches}
                      getOptionLabel={(option) => option.branchName}
                      renderOption={(props, option) => <li {...props}>{option.branchName}</li>}
                      renderInput={(params) => (
                        <TextField
                          onChange={async (e) => {
                            setProcessCenter(e.target.value);
                          }}
                          {...params}
                          fullWidth
                          placeholder="Type Processing Center"
                        />
                      )}
                      value={processCenterId}
                      onChange={(e, newValue) => {
                        setProcessCenterId(newValue);
                      }}
                      inputValue={inputProcessingCenter}
                      onInputChange={(_, v) => setInputProcessingCenter(v)}
                    />
                    <Tooltip title="Add" placement="top" arrow>
                      <IconButton
                        onClick={(e) => handleProcessing()}
                        sx={{
                          bgcolor: 'rgba(19, 81, 157, 0.08)',
                          color: '#13519d',
                          borderRadius: '8px',
                          p: 1,
                          '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
                        }}
                      >
                        <MdOutlineAdd size={20} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box className="">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Bank Contact Person
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Autocomplete
                      sx={{ mr: 1.5 }}
                      disablePortal
                      fullWidth
                      id="combo-box-demo2"
                      options={contactPerson}
                      size="small"
                      getOptionLabel={(option) => option.contactPersonName}
                      renderOption={(props, option) => (
                        <li {...props}>{option.contactPersonName}</li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          onChange={(e) => setAddContPerson(e.target.value)}
                          {...params}
                          fullWidth
                          placeholder="Type Bank Contact Person"
                        />
                      )}
                      value={bankcontactPersonId}
                      onChange={(e, newValue) => {
                        setBankcontactPersonId(newValue);
                      }}
                      inputValue={inputContactPerson}
                      onInputChange={(_, v) => setInputContactPerson(v)}
                    />
                    <Tooltip title="Add" placement="top" arrow>
                      <IconButton
                        onClick={(e) => handleAddBankPerson()}
                        sx={{
                          bgcolor: 'rgba(19, 81, 157, 0.08)',
                          color: '#13519d',
                          borderRadius: '8px',
                          p: 1,
                          '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
                        }}
                      >
                        <MdOutlineAdd size={20} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Box className="">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Comments
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Comments"
                    multiline
                    rows={4}
                    value={summaryComment}
                    onChange={(e) => setSummaryComment(e.target.value)}
                  />
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ mt: 3, textAlign: 'right' }}>
              <Button
                variant="contained"
                onClick={(e) => handleSubmitfrm()}
                sx={{
                  backgroundColor: '#13519d',
                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  px: 3.5,
                  py: 1,
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#0d3b75',
                    boxShadow: 'none'
                  }
                }}
              >
                Submit
              </Button>
            </Box>
          </Card>

          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
              overflow: 'hidden',
              mb: 3
            }}
          >
            <Box sx={{ p: 2.5, pb: 1 }}>
              <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 700, color: '#13519d' }}>
                Summary
              </Typography>
            </Box>
            <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Bank Name</StyledTableCell>
                    <StyledTableCell align="">Mode of Submission</StyledTableCell>
                    <StyledTableCell align="">Processing Center</StyledTableCell>
                    <StyledTableCell align="">Contact Person Name</StyledTableCell>
                    <StyledTableCell align="">Comments</StyledTableCell>
                    <StyledTableCell align="">Submited On</StyledTableCell>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {applicationList.map((item, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell sx={{ fontWeight: 600, color: '#212b36' }}>
                        {item.bankEntity.bankName}
                      </StyledTableCell>
                      <StyledTableCell>{item.submissionMode.typeName}</StyledTableCell>
                      <StyledTableCell>{item.branch.branchName}</StyledTableCell>
                      <StyledTableCell>{item.contactPerson.contactPersonName}</StyledTableCell>
                      <StyledTableCell>{item.submissionComments}</StyledTableCell>
                      <StyledTableCell>{item.submissionDate}</StyledTableCell>
                      <StyledTableCell align="center">
                        <Tooltip title="Delete" placement="top" arrow>
                          <IconButton
                            sx={{
                              color: '#d32f2f',
                              bgcolor: 'rgba(211, 47, 47, 0.08)',
                              mr: 0.5,
                              '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.16)' }
                            }}
                            size="small"
                          >
                            <AiFillDelete size={14} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View" placement="top" arrow>
                          <IconButton
                            sx={{
                              color: '#13519d',
                              bgcolor: 'rgba(19, 81, 157, 0.08)',
                              '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
                            }}
                            size="small"
                          >
                            <AiFillEye size={14} />
                          </IconButton>
                        </Tooltip>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>

          <Dialog
            open={dialogOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { borderRadius: '16px' } }}
          >
            <DialogContent sx={{ p: 3 }}>
              <DialogContentText
                id="alert-dialog-description"
                sx={{ color: '#212b36', fontWeight: 500 }}
              >
                {validationMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: '#13519d',
                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  '&:hover': { backgroundColor: '#0d3b75' }
                }}
              >
                Retry
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
}
export default SubmitLeads;

// Top Banks
// const topBanks = [
//   { label: 'Axis Bank' },
//   { label: 'HDFC Bank' },
//   { label: 'HDFC Ltd.' },
//   { label: 'ICICI Bank' },
//   { label: 'PNB Housing' },
//   { label: 'Piramal Housing' },
//   { label: 'Standard Chartered Bank' },
//   { label: 'Yes Bank' },
//   { label: 'Aditya Birla Housing Finance' },
//   { label: 'IDFC Bank' },
//   { label: 'RBL Bank' },
//   { label: 'Federal Bank' },
//   { label: 'Fedfina' },
//   { label: 'HDB Financial' },
//   { label: 'IIFL Finance' },
//   { label: 'Tata Capital' },
//   { label: 'ICICI Home Finance' },
//   { label: 'Cholamandalam Finance' },
//   { label: 'L&T Finance' },
//   { label: 'Karur Vysya Bank' },
//   { label: 'Hero Housing Finance' },
//   { label: 'Kotak Mahindra Bank' },
//   { label: 'Fullerton Grihashakti' },
//   { label: 'Anand Rathi Financial' },
//   { label: 'Aadhar Housing Finance' },
//   { label: 'Godrej Housing Finance' },
//   { label: 'Deutsche Bank' },
//   { label: 'Jana Small Finance Bank' },
//   { label: 'HSBC Bank' },
//   { label: 'DCB Bank' },
//   { label: 'Bank of Baroda' },
//   { label: 'Bajaj Housing Finance' },
//   { label: 'LIC Housing Finance' },
//   { label: 'AU Small Finance Bank' },
//   { label: 'Union Bank of India' },
//   { label: 'State Bank of India' }
// ];
